import { DefaultPage } from './';

export default {
  path: 'knowledge-base/:version/v',
  name: 'Knowledge base',
  childRoutes: [
    { path: ':projectId', name: 'Default page', component: DefaultPage, isPrivate: true },
  ],
};
